import { Vue, Component, Watch } from 'vue-property-decorator';
import axios from 'axios';
import XLSX from 'xlsx';
import Excel from 'exceljs';
import cloneDeep from 'lodash/cloneDeep';
import { isTypeElement } from 'typescript';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';

const EXPORT_TYPE = {
  skill: 'skill', // 秒杀
  remit: 'remit', // 结算
  site: 'site', // 网点
  goods: 'goods', // 选择商品
  live: 'live', // 直播
  proCommission: 'proCommission', // 分销
  distributor: 'distributor', // 分销员管理
  importgoodsnum: 'importgoodsnum', // 导入货号
};

const LOCAL_EXPORT = [EXPORT_TYPE.skill, EXPORT_TYPE.goods, EXPORT_TYPE.importgoodsnum]; // 本地导出文件

const SERVICE_EXPORT = [EXPORT_TYPE.remit, EXPORT_TYPE.site, EXPORT_TYPE.live, EXPORT_TYPE.proCommission, EXPORT_TYPE.distributor]; // 服务器导出文件

@DialogFactory
@Component({
  mixins: [style],
})
export default class ImportBatchSet extends IPSDialog {
  /**
   * 文件上传地址
   * @type {string}
   */
  fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  corpId = baseAPIService.resolveCorpId();

  // 按钮状态
  exportBtnInfo = [
    { state: 0, url: '' },
    { state: 0, url: '' },
    { state: 0, url: '' },
  ];

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  // socket准备状态
  isSocketReady = false;

  // 失败数据数量
  failNum = 0;

  // 失败数据文件下载地址
  failFileURL = '';

  // 导入的文件名称
  fileName = '';

  // 导入的文件
  importFile: any = {};

  width = '530px';

  confirm = false;

  cancelText = '关闭';

  // 失败数据列表 本地导出和导入时用
  errorList = [];

  // 返回数据 本地导出合导入时用
  resultData = [];

  loading = false;
  /**
   * 导入状态 1 导入中 2 导入成功 3 导入失败
   * @type {number}
   */
  importState = 0;

  // 本地生成文件名称
  name = '秒杀商品';

  // 不存在 action 则为本地生成导出文件
  setInfo = {
    site: {
      step1: '请下载模板文件,并根据模板中的范例，仔细准备数据',
      step2: '请将配置好数据的模板文件导入系统',
      download: [
        {
          text: '下载模板',
          action: 'splitTemplateExport',
          sendToId: `${appEnvConfig.NODE_ENV}siteConfig`,
          funKey: 'onExportSplitTemplate',
        },
      ],
    },
    remit: {
      step1: '请下载含数据模板,并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则编辑上传文件,并在此导入',
      download: [
        // {
        //   text: "下载合计数据模板",
        //   action: "vGuderTemplateOneOut",
        //   sendToId: appEnvConfig.NODE_ENV + "templateCount",
        //   funKey: "onExportGuderTemplateOneOu",
        // },
        {
          text: '下载含数据导入模板',
          action: 'vGuderTemplateTwoOut',
          sendToId: `${appEnvConfig.NODE_ENV}templateImport`,
          funKey: 'onExportGuderTemplateTwoOut',
        },
      ],
    },
    skill: {
      step1: '请下载含数据模板,并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则编辑上传文件,并在此导入',
      download: [
        {
          text: '下载含数据模板',
          action: '',
          sendToId: `${appEnvConfig.NODE_ENV}skillProduct`,
          funKey: 'onExportSkillProduct',
        },
      ],
    },
    goods: {
      step1: '请下载含数据模板,并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则编辑上传文件,并在此导入',
      download: [
        {
          text: '下载模板',
          action: '',
          sendToId: `${appEnvConfig.NODE_ENV}productImportSearch`,
          funKey: 'onExportProduct',
        },
      ],
    },
    live: {
      step1: '请下载含数据模板，并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则上传文件，并在此导入',
      download: [
        {
          text: '下载含数据模板',
          action: 'liveViewInfo',
          sendToId: `${appEnvConfig.NODE_ENV}liveProduct`,
          funKey: 'onExportLiveProduct',
        },
      ],
    },
    proCommission: {
      step1: '请下载含数据模板，并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则上传文件，并在此导入',
      download: [
        {
          text: '下载含数据模板',
          action: 'proComTemplateExport',
          sendToId: `${appEnvConfig.NODE_ENV}proCommission`,
          funKey: 'onExportProCommission',
        },
        {
          text: '下载空白模板',
          action: '',
          sendToId: `${appEnvConfig.NODE_ENV}proCommissionTemplate`,
          funKey: 'onExportProCommissionTemplate',
        },
      ],
    },
    distributor: {
      step1: '请下载含数据模板，并根据模板中的数据项准备数据',
      step2: '请根据模板中的相关规则上传文件，并在此导入',
      download: [
        {
          text: '下载含数据模板',
          action: 'distributorChangeExport',
          sendToId: `${appEnvConfig.NODE_ENV}distributor`,
          funKey: 'onExportDistributor',
        },
        {
          text: '下载空白模板',
          action: '',
          sendToId: `${appEnvConfig.NODE_ENV}distributorTemplate`,
          funKey: 'onExportDistributorTemplate',
        },
      ],
    },
    importgoodsnum: {
      // 导入货号
      tip: '仅针对在商城上架的商品货号生效',
      step1: '请下载模板文件，并根据模板中的范例，仔细准备数据',
      step2: '请将配置好的数据的把模板导入系统',
      download: [
        // {
        //   text: "下载含数据模板",
        //   action: "distributorChangeExport",
        //   sendToId: appEnvConfig.NODE_ENV + "distributor",
        //   funKey: "onExportDistributor",
        // },
        {
          text: '下载模板',
          action: '',
          sendToId: `${appEnvConfig.NODE_ENV}distributorTemplate`,
          funKey: '',
        },
      ],
    },
  };

  importSendToId = `${appEnvConfig.NODE_ENV}import`;

  /**
   * prop
   */

  // 导入地址
  importUrl = '';

  // 导入参数
  importParams = '';

  // 员工编号
  empCode = '';

  // 弹窗标题
  title = '';

  // 来源
  fromKey = '';

  // 发送导出请求参数
  postParams = {};

  // 本地导出时列表数据
  data = [];

  // 本地生成文件的 header
  excelHeader: Array<{ header?: string; key?: string; width?: number }> = [];

  // 文件限制大小 0 不限制
  maxSize = 0;

  isCloudMall = 0;

  mounted() {
    this.closeSockets();
    this.createConnect();
    Object.keys(this.setInfo).map((k) => {
      this.setInfo[k].download = this.setInfo[k].download.map((v) => {
        v.sendToId = v.sendToId + this.empCode;
        return v;
      });
    });
    this.importSendToId = this.importSendToId + this.empCode;
  }

  // 关闭时
  onCancel() {
    this.$emit('result', { flag: this.importState == 2, result: this.resultData });
    this.$emit('hidden');
  }

  // 创建socket
  createConnect(index = 0, sendToId = '') {
    setTimeout(() => {
      this.$socket.connect();
      this.onSokectConnect(index, sendToId);
    }, 0);
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  // 关闭socket
  public closeSockets() {
    this.sockets && this.sockets.unsubscribe && this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket && this.$socket.disconnect(); // 断开连接
  }

  /**
   * socket连接
   * success fail finish 三种状态
   * success 倒数第二位为 1 导出成功 为 0 导入成功
   * 导出成功时 优先取七牛下载地址 地址在第四位 兼容之前第二位的文件地址
   * fail    导出时生成excecl失败
   * finish  导入文件有失败数据 第四位为失败文件下载地址 倒数第二位为导入失败数据数量
   */
  onSokectConnect(index = 0, sendToId) {
    this.$socket.emit('login', sendToId || this.setInfo[this.fromKey].download[index].sendToId);
    this.sockets.subscribe('new_msg', (msg) => {
      if (msg) {
        const msgArr = msg.split('|');
        //  导入和导出成功
        if (msgArr[0] === 'success') {
          // 导出成功
          if (msgArr[msgArr.length - 2] === '1') {
            const qiniuUrl = msgArr[3];
            this.$set(this.exportBtnInfo, index, {
              state: 2,
              url: qiniuUrl || `${Functions.ipsHostUrlApi()}/file/download?fileUrl=${msgArr[1]}`,
            });
          }
          // 导入成功
          if (msgArr[msgArr.length - 2] === '0') {
            this.importState = 2;
            // this.$message.success('导入成功');
            this.$emit('result', { flag: this.importState == 2, result: this.resultData });
          }
          // 生成文件失败(导出)
        } else if (msgArr[0] === 'fail') {
          this.$message.error('生成EXCEL失败');
          this.$set(this.exportBtnInfo, index, { state: 0, url: '' });
          // 导入失败
        } else {
          this.failNum = Number(msgArr[msgArr.length - 2]) || 0;
          this.importState = 3;
          this.failFileURL = msgArr[3];
          this.fromKey === EXPORT_TYPE.live && this.$emit('result', { flag: this.importState == 2, result: this.resultData });
        }
      }
    });
  }

  // 导出文件
  onExport(index = 0, action, sendToId) {
    if (!this.isSocketReady) {
      return false;
    }
    this.closeSockets();
    this.createConnect(index);
    this.$set(this.exportBtnInfo, index, { state: 1, url: '' });
    if (SERVICE_EXPORT.includes(this.fromKey) && action) {
      IPSService[action]({ postParams: Object.assign(this.postParams, { sendToId }) }).then((result) => {
        if (this.fromKey === EXPORT_TYPE.live) {
          const liveGoodsList = result.list || [];
          let allGoodLst = [];
          liveGoodsList.forEach((i) => {
            const sku = (i.skuItems || []).map((v) => {
              v.productCode = i.productCode;
              return v;
            });
            allGoodLst = [].concat(allGoodLst, sku);
          });

          Functions.excelMaker({
            columns: [
              { header: '货号', key: 'productCode', width: 15 },
              { header: '条码', key: 'sku', width: 30 },
              { header: '规格', key: 'specVal', width: 20 },
              { header: '直播价(元)', key: 'price', width: 20 },
              { header: '库存', key: 'stock', width: 20 },
            ],
            data: allGoodLst,
            name: '库存价格数据模板',
          });
          this.$set(this.exportBtnInfo, index, { state: 0, url: '' });
        }
      });
    } else {
      // 前端生成excel
      Functions.excelMaker({
        columns: this.excelHeader,
        data: this.data,
        name: this.name,
      });
      this.$set(this.exportBtnInfo, index, { state: 0, url: '' });
    }
  }

  // 下载导出文件
  downloadFile(index = 0) {
    location.href = this.exportBtnInfo[index].url;
    setTimeout(() => {
      this.$set(this.exportBtnInfo, index, { state: 0, url: '' });
    }, 2000);
  }

  // 上传之前校验文件
  onBeforeUpload(file: ItemObject): boolean {
    const fileType = file.name.slice(Math.max(0, file.name.lastIndexOf('.') + 1));
    const extension2 = fileType === 'xlsx';
    this.fileName = file.name;
    this.importFile = file;
    let result = true;
    if (!extension2) {
      this.$message({
        message: '上传文件只能是 xls、xlsx、excel格式!',
        type: 'warning',
      });
      result = false;
    }
    if (this.maxSize) {
      const LtSize = file.size / 1024 <= this.maxSize;
      if (!LtSize) {
        this.$message.error(`上传文件大小不能超过${this.maxSize / 1024}M!`);
        result = false;
      }
    }
    return result;
  }

  // 上传成功
  uploaduccess() {
    this.$message.success('文件上传成功');
  }

  // 上传失败
  uploadError() {
    this.$message.error('文件上传失败');
  }

  // 导入文件
  onImport() {
    this.loading = true;
    if (this.fileName === '') {
      this.$message.warning('请选择要上传的文件');
      return;
    }
    this.importState = 1;
    // 此处添加setTimeout,是为了将导入中展示出来，由于函数处理问题，会将这面一系列在微任务中运行，所以页面没有渲染，使用了this.$forceUpdate()和this.$nextTick()均无效
    setTimeout(() => {
      if (SERVICE_EXPORT.includes(this.fromKey)) {
        const fileFormData = new FormData();
        fileFormData.append('sendToId', this.importSendToId);
        Object.keys(this.importParams).forEach((key) => {
          fileFormData.append(key, this.importParams[key]);
        });
        fileFormData.append('file', this.importFile, this.fileName);
        this.closeSockets();
        this.createConnect(0, this.importSendToId);
        axios({
          url: `${this.importUrl}?corpId=${this.corpId}`,
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': this.tokenData.Authorization,
          },
          data: fileFormData,
        })
          .then()
          .catch((err) => {
            console.log(err);
          });
      } else {
        switch (this.fromKey) {
          case EXPORT_TYPE.skill:
            this.readerSkillExcel();
            break;
          case EXPORT_TYPE.goods:
            this.readerGoodsExcel();
            break;
          case EXPORT_TYPE.importgoodsnum:
            this.readerGoodsnumExcel();
          default:
            break;
        }
      }
      this.importFile = null;
      this.fileName = '';
    }, 50);
  }

  // 下载失败文件
  downloadFailFile() {
    if (SERVICE_EXPORT.includes(this.fromKey)) {
      location.href = this.failFileURL;
    } else {
      switch (this.fromKey) {
        case EXPORT_TYPE.skill:
          this.downloadSkillFailFile();
          break;
        case EXPORT_TYPE.goods:
          this.downloadGoodsFailFile();
          break;
        case EXPORT_TYPE.importgoodsnum:
          this.downloadGoodsnumFailFile();
          break;
        default:
          break;
      }
    }
  }

  // 下载秒杀导入失败文件
  downloadSkillFailFile() {
    let columns = this.excelHeader
    columns.push({ header: '失败原因', key: 'text', width: 40 });
    columns = columns.filter((item, index, arr) => {
      return arr.findIndex(el => el.key === item.key) === index
    })
    Functions.excelMaker({
      columns,
      data: this.errorList,
      name: '秒杀商品',
    });
  }

  // 下载选择商品导入失败文件
  downloadGoodsFailFile() {
    const columns = this.excelHeader;
    columns.push({ header: '失败原因', key: 'text', width: 40 });
    Functions.excelMaker({
      columns,
      data: this.errorList,
      name: '选择商品',
    });
  }

  // 下载选择图标导入失败文件
  downloadGoodsnumFailFile() {
    const columns = this.excelHeader;
    columns.push({ header: '失败原因', key: 'text', width: 40 });
    Functions.excelMaker({
      columns,
      data: this.errorList,
      name: '导入商品',
    });
  }

  // 处理秒杀excel数据
  readerSkillExcel() {
    Functions.readExcel(this.importFile).then((excelData: Array<any>) => {
      //  去除表头数据
      excelData.splice(0, 5);
      excelData.splice(- 1, 1);
      console.log(excelData)
      while (excelData && excelData.length) {
        const temp = excelData.splice(0, 5);
        const productCode = temp[0] ? temp[0].v : '';
        const sku = temp[1] ? temp[1].v : '';
        const specVal = temp[2] ? temp[2].v : '';
        const price = temp[3] ? temp[3].v : '';
        const stock = temp[4] ? temp[4].v : '';
        if (this.data.some(v => v.sku === sku)) {
          this.resultData.push({ productCode, sku, specVal, price, stock });
        } else {
          this.errorList.push({ productCode, sku, specVal, price, stock, text: '条码不存在' });
        }
      }
      const failList = this.resultData.filter(v => !(Number(v.price) > 0 && Number(v.stock) >= 0) || String(v.stock).indexOf('.') > 0);
      this.errorList = this.errorList.concat(
        failList.map((v) => {
          const temp = this.data.find(d => d.sku === v.sku);
          return {
            productCode: temp.productCode,
            sku: temp.sku,
            specVal: temp.specVal,
            price: v.price,
            stock: v.stock,
            text: '价格或库存输入错误',
          };
        }),
      );
      this.resultData = this.resultData.filter(v => Number(v.price) > 0 && Number(v.stock) >= 0 && !(String(v.stock).indexOf('.') > 0));
      if (!this.errorList || !this.errorList.length) {
        this.importState = 2;
      } else {
        this.failNum = this.errorList.length;
        this.importState = 3;
      }
      // 原来的flag是！！importState，即除了导入未开始之前flag都会是true
      this.$emit('result', { flag: this.importState == 2, result: this.resultData });
    });
  }

  // 处理选择商品数据
  readerGoodsExcel() {
    Functions.readExcelWithNumber(this.importFile).then((excelData: any) => {
      // 去除首尾数据
      // 由于新增了sort字段
      if (this.isCloudMall) {
        excelData.list.splice(0, excelData.deleteNum);
        while (excelData && excelData.list && excelData.list.length) {
          const temp = excelData.list.splice(0, excelData.deleteNum);
          const productCode = temp[0] ? temp[0].v : '';
          const sort = temp[1] ? temp[1].v : 0;
          this.resultData.push({ productCode, sort });
          this.errorList = excelData.list.map((v) => {
            return {
              productCode: v,
              text: '货号不存在',
            };
          });
        }
      } else {
        excelData.list.shift();
        this.errorList = excelData.list
          .filter(e => !e)
          .map((v) => {
            return {
              productCode: v,
              text: '货号不存在',
            };
          });
        this.resultData = excelData.list.map(v => v.v);
      }
      this.$emit('result', { flag: !!this.resultData.length, result: this.resultData });
      this.$emit('hidden');
    });
  }

  // 处理导入货号数据
  readerGoodsnumExcel() {
    Functions.readExcel(this.importFile).then((excelData: Array<any>) => {
      // 去除首尾数据
      excelData.pop();
      excelData.shift();
      this.errorList = excelData
        .filter(e => !e)
        .map((v) => {
          return {
            productCode: v,
            text: '货号不存在',
          };
        });
      this.resultData = excelData.filter(e => !!e).map(v => v.v);
      this.$emit('result', { flag: !!this.resultData.length, result: this.resultData });
      if (!this.errorList || !this.errorList.length) {
        this.importState = 2;
      } else {
        this.failNum = this.errorList.length;
        this.importState = 3;
      }
      this.$emit('hidden');
    });
  }

  renderContent(h) {
    return (
      <div class="batch-site-container">
        {this.importState == 0 && (
          <div>
            {this.setInfo[this.fromKey].tip && (
              <p class="tip">
                <i class="redText">*&nbsp;</i>
                {this.setInfo[this.fromKey].tip}
              </p>
            )}

            <div class="blockTitle">Step1</div>
            <div class="blockTitle subtitle">{this.setInfo[this.fromKey].step1}</div>
            <div class="template-download">
              {this.setInfo[this.fromKey].download.map((v, i) => {
                return (
                  <span>
                    {this.exportBtnInfo[i].state === 0 && (
                      <span class={{ scopeSpan: true, disabled: !this.isSocketReady }} onClick={this.onExport.bind(this, i, v.action, v.sendToId)}>
                        {v.text}
                      </span>
                    )}
                    {this.exportBtnInfo[i].state === 1 && <span class="scopeSpan disabled">文件生成中...</span>}
                    {this.exportBtnInfo[i].state === 2 && (
                      <span class="scopeSpan" onClick={this.downloadFile.bind(this, i)}>
                        下载
                      </span>
                    )}
                  </span>
                );
              })}
            </div>
            <br />
            <div class="blockTitle">Step2</div>
            <div class="blockTitle subtitle">{this.setInfo[this.fromKey].step2}</div>
            <div class="flex">
              <el-input placeholder="请选择文件" value={this.fileName} disabled={true} style="width: 80%">
                <template slot="append">
                  <el-upload
                    action={this.fileTpConfig}
                    multiple={false}
                    headers={this.tokenData}
                    before-upload={this.onBeforeUpload}
                    on-success={this.uploaduccess}
                    on-error={this.uploadError}
                    show-file-list={false}
                    data={{ coprId: this.corpId }}
                    accept=".xlsx">
                    <el-button size="small" type="primary" slot="trigger">
                      选择
                    </el-button>
                  </el-upload>
                </template>
              </el-input>
              <el-button class="r-ml-20 flex1" type="primary" onClick={this.onImport.bind(this)} loading={this.loading} disabled={!this.fileName}>
                导入
              </el-button>
            </div>
            <br />
            <div class="blockTitle">Step3</div>
            <div class="blockTitle subtitle">确认导入结果</div>
          </div>
        )}
        {this.importState == 1 && <p class="text">正在准备导入中...</p>}
        {this.importState == 2 && <p class="text">导入成功</p>}
        {this.importState == 3 && [
          <p class="text">导入结果: 失败{this.failNum}</p>,
          <el-button class="block r-my-0 r-mx-auto" type="primary" onClick={this.downloadFailFile.bind(this)}>
            下载失败结果
          </el-button>,
        ]}
      </div>
    );
  }
}
